// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3kGDA","savePackageButton":"ClientWallet_savePackageButton__6cjhA"};